import React, { FC, ReactNode } from 'react';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import './plan-includes.component.css';

const INCLUDED_FEATURES: Array<{ icon: ReactNode; title: string; body: string }> = [
  {
    icon: <GroupsOutlinedIcon />,
    title: 'Groups within teams',
    body: 'Split a team into squads. Each group gets its own plan.',
  },
  {
    icon: <CalendarMonthOutlinedIcon />,
    title: 'Team Training Plan',
    body: 'Plan by group. Publish when the week is ready.',
  },
  { icon: <EventNoteOutlinedIcon />, title: 'Schedule', body: 'Team, personal and guardian sessions on one board.' },
  { icon: <ShowChartOutlinedIcon />, title: 'Training Log', body: 'Duration, distance, ascent and zones per session.' },
  { icon: <BarChartOutlinedIcon />, title: 'Athlete Stats', body: 'Every athlete, every week, sorted how you want.' },
  {
    icon: <Inventory2OutlinedIcon />,
    title: 'Equipment',
    body: 'Skis, shoes, bikes, poles. Attach any of it to a session or a race.',
  },
  { icon: <EmojiEventsOutlinedIcon />, title: 'Race Log', body: 'Finish, age group and the equipment that ran it.' },
  {
    icon: <ChatBubbleOutlineOutlinedIcon />,
    title: 'Chat, Forms and Message Board',
    body: 'Direct messages, a team board, and forms on a session.',
  },
];

const PlanIncludes: FC = () => (
  <div className="plan-inc">
    <div className="plan-inc-head">
      <div className="plan-inc-lbl">What every plan includes</div>
      <em>The whole platform. No tier holds a feature back.</em>
    </div>
    <div className="plan-inc-grid">
      {INCLUDED_FEATURES.map((feature) => (
        <div className="plan-inc-item" key={feature.title}>
          <i>{feature.icon}</i>
          <b>{feature.title}</b>
          <span>{feature.body}</span>
        </div>
      ))}
    </div>
  </div>
);

export default PlanIncludes;
